class CustomQtyATC extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }
  connectedCallback() {
    this.addEventListener("click", this.handleClick);
    this.syncQtyFromCart();

    this.cartUpdateListener = this.handleCartUpdate.bind(this);
    document.addEventListener("cart:updated", this.cartUpdateListener);
  }
  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick);
    document.removeEventListener("cart:updated", this.cartUpdateListener);
  }
  handleClick(e) {
    var atcBtn = e.target.closest(".atc_btn_JS"),
        plusBtn = e.target.closest(".qty_btn.plus"),
        minusBtn = e.target.closest(".qty_btn.minus"),
        container = this,
        qtyValEl = container.querySelector(".qty_value"),
        qty = parseInt(qtyValEl.getAttribute("qty_value")) || 0,
        inventory = parseInt(container.getAttribute("inventory_quantity")) || 0,
        variantid = parseInt(container.getAttribute("variantid")),
        variantPrice = parseInt(container.getAttribute("variantPrice")),
        image = container.getAttribute("image");

    if (atcBtn) {
      container.classList.remove("qty_hide");
      qty++;
    }
    if (plusBtn) {
      qty++;
    }
    if (minusBtn) {
      if (qty <= 1) {
        container.classList.add("qty_hide");
        qty = 0;
      } else {
        qty--;
      }
    }
    qtyValEl.textContent = qty;
    qtyValEl.setAttribute("qty_value", qty);
    
    var plus = container.querySelector(".qty_btn.plus");
    if (qty >= inventory) {
      plus.classList.add("disabled");
    } else {
      plus.classList.remove("disabled");
    }

    if(container.closest('.pack-of-bundle')){
      if (atcBtn || plusBtn || minusBtn) {
        let isAdd = atcBtn || plusBtn;
        handleBundleUpdate(container, variantid, variantPrice, image, isAdd ? 'add' : 'remove');
      }
    }
  }

  syncQtyFromCart() {
    if(this.closest('.pack-of-bundle')) return;
    
        var container = this,
            variantid = parseInt(container.getAttribute("variantid")),
            cartItems = JSON.parse(localStorage.getItem('cartItemLocalStorage') || '[]'),
            item = cartItems.find(i => i.id == variantid),
            qtyValEl = container.querySelector(".qty_value");

        if(item){
          qtyValEl.textContent = item.quantity;
          qtyValEl.setAttribute("qty_value", item.quantity);
          container.classList.remove("qty_hide");
        }else{
          qtyValEl.textContent = 0;
          qtyValEl.setAttribute("qty_value", 0);
          container.classList.add("qty_hide");
        }
    }
    handleCartUpdate(e) {
      if(this.closest('.pack-of-bundle')) return;
        var container = this,
            variantid = parseInt(container.getAttribute("variantid")),
            qtyValEl = container.querySelector(".qty_value");

        if (variantid == e.detail.variantId) {
            var qty = e.detail.qty;

            qtyValEl.textContent = qty;
            qtyValEl.setAttribute("qty_value", qty);

            if (qty > 0) {
                container.classList.remove("qty_hide");
            } else {
                container.classList.add("qty_hide");
            }
        }
    }
}

if (!customElements.get("custom-qty-atc")) {
  customElements.define("custom-qty-atc", CustomQtyATC);
}

window.bundleItems = window.bundleItems || [];

function handleBundleUpdate(container, variantid, variantPrice, image, action) {
    var bundleContainer = container.closest('.pack_of_bundle_inner'),
        maxQuantity = parseInt(bundleContainer.getAttribute('data-maxQuantity')),
        qtyValEl = container.querySelector(".qty_value");

    if (action === 'add') {
        if (window.bundleItems.length < maxQuantity) {
            window.bundleItems.push({ variantid: variantid, price: variantPrice, image: image, container: container });
        } else {
            var currentQty = parseInt(qtyValEl.getAttribute("qty_value")) || 1,
                revertedQty = currentQty - 1;

            if(revertedQty <= 0) {
                revertedQty = 0;
                container.classList.add("qty_hide");
            }
            qtyValEl.textContent = revertedQty;
            qtyValEl.setAttribute("qty_value", revertedQty);
            return;
        }
    } else if (action === 'remove') {
        var indexToRemove = window.bundleItems.map(item => item.variantid).lastIndexOf(variantid);
        if (indexToRemove !== -1) {
            window.bundleItems.splice(indexToRemove, 1);
        }
    }
    
    renderBundleCart(bundleContainer);
}

function renderBundleCart(bundleContainer) {
    var maxQuantity = parseInt(bundleContainer.getAttribute('data-maxQuantity')),
        slots = bundleContainer.querySelectorAll('.selected_product_slot'),
        totalCount = window.bundleItems.length,
        totalPrice = 0;

    slots.forEach((slot, index) => {
        var item = window.bundleItems[index],
            removeIcon = slot.querySelector('.remove_item'),
            img = slot.querySelector('img');

        if (item) {
            if (!img) {
                var imageTag = `<img src="${item.image}">`;
                slot.insertAdjacentHTML('beforeend', imageTag);
            } else {
                img.src = item.image;
            }
            
            slot.setAttribute('data-variantid', item.variantid);
            slot.setAttribute('data-price', item.price);

            totalPrice += item.price;
        } else {
            slot.removeAttribute('data-variantid');
            if (img) img.remove(); 
        }
    });

    var selectionInfo = bundleContainer.querySelector('.selectionInfo'),
        countEl = bundleContainer.querySelector('.fillCount'),
        priceEl = bundleContainer.querySelector('.price_inner'),
        comparePriceEl = bundleContainer.querySelector('.compare_price_inner'),
        maxPrice = totalPrice,
        comparePrice = totalPrice;

    if (countEl) countEl.textContent = totalCount;

    if (totalCount >= maxQuantity) {
        maxPrice = Math.max(...window.bundleItems.map(item => item.price));

        selectionInfo.innerHTML = `Congratulations! you get the bundle at ${Shopify.formatMoney(maxPrice,window.moneyFormat)}`;
    } else {
        maxPrice = totalPrice;

        selectionInfo.innerHTML = `Select ${maxQuantity - totalCount} more item(s) to get the bundle at ${Shopify.formatMoney(maxPrice,window.moneyFormat)}`;
    }

    if (priceEl) priceEl.innerHTML = Shopify.formatMoney(maxPrice,window.moneyFormat);
    if (comparePriceEl) comparePriceEl.innerHTML = Shopify.formatMoney(comparePrice,window.moneyFormat);
    
    var finalAtc = bundleContainer.querySelector('.final_atc_inner'),
        allPlusBtns = bundleContainer.querySelectorAll('.qty_btn.plus, .atc_btn_JS');

    if (totalCount >= maxQuantity) {
        finalAtc.classList.remove('disabled');
        allPlusBtns.forEach(btn => {
            btn.style.pointerEvents = 'none';
            btn.style.opacity = '0.5';
        });
        bundleContainer.classList.add("stopNewATC");
    } else {
        finalAtc.classList.add('disabled');
        allPlusBtns.forEach(btn => {
            btn.style.pointerEvents = '';
            btn.style.opacity = '';
        });
        bundleContainer.classList.remove("stopNewATC");
    }
}

document.addEventListener("click", function(e) {
    var removeBtn = e.target.closest('.pack_of_bundle_inner .remove_item');
    if (removeBtn) {
        var slot = removeBtn.closest('.selected_product_slot'),
            variantid = parseInt(slot.getAttribute('data-variantid'));
        
        if (variantid && window.bundleItems) {
            var indexToRemove = window.bundleItems.map(item => item.variantid).lastIndexOf(variantid);
            
            if (indexToRemove !== -1) {
                var containerToUpdate = window.bundleItems[indexToRemove].container;
                window.bundleItems.splice(indexToRemove, 1);
                
                if (containerToUpdate) {
                    var qtyValEl = containerToUpdate.querySelector(".qty_value"),
                        currentQty = parseInt(qtyValEl.getAttribute("qty_value")) || 0,
                        newQty = currentQty - 1;
                    
                    if (newQty <= 0) {
                        newQty = 0;
                        containerToUpdate.classList.add("qty_hide");
                    }
                    
                    qtyValEl.textContent = newQty;
                    qtyValEl.setAttribute("qty_value", newQty);
                }
                
                var bundleContainer = removeBtn.closest('.pack_of_bundle_inner');
                renderBundleCart(bundleContainer);
            }
        }
    }

    var finalAtcBtn = e.target.closest('.final_atc_inner');
    if (finalAtcBtn && !finalAtcBtn.classList.contains('disabled')){
        var itemsToAdd = {};
        window.bundleItems.forEach(function(item) {
            if (itemsToAdd[item.variantid]) {
                itemsToAdd[item.variantid] += 1;
            } else {
                itemsToAdd[item.variantid] = 1;
            }
        });

        var cartItems = Object.keys(itemsToAdd).map(function(variantId) { 
            return variantId + ':' + itemsToAdd[variantId]; 
        }).join(','); 
        window.location.href = '/cart/' + cartItems;
    }

    var packOfBundleBtnQV = e.target.closest('.pack_of_bundle_page_btn_inner');
    if (packOfBundleBtnQV) {
        var productInfo = packOfBundleBtnQV.closest("product-info");

        if (!productInfo) return;

        var variantInput = productInfo.querySelector("input.product-variant-id"),
            productInput = productInfo.querySelector('input[name="product-id"]');

        if (!variantInput || !productInput) return;

        var variantID = String(variantInput.value),
            productID = String(productInput.value),
            singleCard = Array.from(document.querySelectorAll(".shopify-section.pack-of-bundle .new_product_card")).find(function(card) {
                return String(card.getAttribute("dataProductId")) === productID;
            });

        if (!singleCard) return;
        
        var variantsJsonEl = singleCard.querySelector('.product-variants-json'),
            allSelectors = singleCard.querySelectorAll('.single_option_selector');
            
            if (variantsJsonEl && allSelectors.length > 0) {
                var variants = JSON.parse(variantsJsonEl.textContent);
            
            var matchedVariant = variants.find(function(v) {
                return v.id == variantID;
                
            });
            
            if (matchedVariant) {
                allSelectors.forEach(function(select, index) {
                    select.value = matchedVariant.options[index];
                });
                
                allSelectors[0].dispatchEvent(new Event("change", { bubbles: true }));

                var quickViewContainer = document.querySelector(".product-quick-view-container .product-quick-view__close");
                if (quickViewContainer) {
                    quickViewContainer.click();
                    
                    var atcBtn = singleCard.querySelector(".product_atc_inner .atc_btn_JS");
                    if (atcBtn) {
                        setTimeout(function() {
                            atcBtn.click();
                        }, 100);
                    }
                }
            }
        }        
    }
});

function setPackOfBundleHeight() {
  if (document.querySelector('.pack-of-bundle .buil_bundle')) {
    var packOfBundleHeight = document.querySelector('.pack-of-bundle .buil_bundle').offsetHeight;
    document.documentElement.style.setProperty('--pack-of-bundle-height', `${packOfBundleHeight}px`);
  }
}

document.addEventListener('shopify:section:load', setPackOfBundleHeight);
document.addEventListener('DOMContentLoaded', setPackOfBundleHeight);

subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
  var variant = event.data.variant;
  if(document.querySelector("body.template-page-pack-of-bundle")){
    var bundlePageQVBTN = document.querySelector(".product-quick-view-container .pack_of_bundle_page_btn .pack_of_bundle_page_btn_inner");
    if(bundlePageQVBTN){
      if(variant.available){
        bundlePageQVBTN.innerHTML = window.variantStrings.addToCart;
        bundlePageQVBTN.removeAttribute("disabled");
    }else{
        bundlePageQVBTN.innerHTML = window.variantStrings.soldOut;
        bundlePageQVBTN.setAttribute("disabled",true);
      }
    }
  }
});

// document.addEventListener("change", function(e) {
//     var variantBox = e.target.closest('.pack_of_bundle_inner .variant_selector .variant_picker');
//     if (variantBox) {
//         var currentID = variantBox.value;
//         variantBox.closest('.product_atc_inner').querySelector('custom-qty-atc').setAttribute('variantid', currentID);
//     }
// });

document.addEventListener("change", function(e) {
    var singleOptionSelector = e.target.closest('.pack_of_bundle_inner .single_option_selector');
    if (singleOptionSelector) {
        var productCard = singleOptionSelector.closest('.new_product_card'),
            allSelectors = productCard.querySelectorAll('.single_option_selector'),
            variantsJsonEl = productCard.querySelector('.product-variants-json');
        
        if (!variantsJsonEl) return;
        var variants = JSON.parse(variantsJsonEl.textContent);
        var selectedOptions = Array.from(allSelectors).map(function(select) {
            return select.value;
        });
        
        var matchedVariant = variants.find(function(variant) {
            return variant.options.every(function(optionValue, index) {
                return optionValue === selectedOptions[index];
            });
        });
        
        var customQtyAtc = productCard.querySelector('custom-qty-atc'),
            priceEl = productCard.querySelector('.sell_price'),
            comparePriceEl = productCard.querySelector('.comp_price');
        
        if (matchedVariant) {
            customQtyAtc.setAttribute('variantid', matchedVariant.id);
            customQtyAtc.setAttribute('variantPrice', matchedVariant.price);
            
            if (priceEl && typeof Shopify !== 'undefined' && Shopify.formatMoney) {
                priceEl.innerHTML = Shopify.formatMoney(matchedVariant.price, window.moneyFormat);
            }
            if (comparePriceEl && matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
                comparePriceEl.innerHTML = Shopify.formatMoney(matchedVariant.compare_at_price, window.moneyFormat);
                comparePriceEl.style.display = 'inline-block';
            } else if (comparePriceEl) {
                comparePriceEl.style.display = 'none';
            }
        }
    }
});

document.addEventListener('DOMContentLoaded', function(){
    // Works for both online URLs and local file paths (e.g., './data.json')
    fetch('/cart.json')
    .then(response => {
        if (!response.ok) {
        throw new Error('Network response was not ok');
        }
        return response.json(); // Parses the JSON into a JS object
    })
    .then(data => {
        removeFreeGift(data);
    })
    .catch(error => {
        console.error('There was a problem fetching the data:', error);
    });
});

function removeFreeGift(cartData){

    const freeGiftOffer = document.querySelector('.free_gift_offer_js');

    if (!freeGiftOffer) return;

    const minimumCartTotal = Number(
      freeGiftOffer.dataset.minimumCartTotal
    );

    const freeGiftVariantId = Number(
      freeGiftOffer.dataset.freeGiftVariantId
    );

    if (!minimumCartTotal || !freeGiftVariantId) return;

    if (cartData.total_price >= minimumCartTotal) return;

    const freeGiftItemIndex = cartData.items.findIndex(
      (item) => Number(item.variant_id) === freeGiftVariantId
    );

    if (freeGiftItemIndex === -1) return;

    const freeGiftLine = freeGiftItemIndex + 1;
    const removeButton = document.querySelector(`#Remove-${freeGiftLine}`) || document.querySelector(`#CartDrawer-Remove-${freeGiftLine}`);

    if (!removeButton) {
      console.warn('Free gift remove button not found:', freeGiftLine);
      return;
    }

    const removeLink = removeButton.querySelector('a');

    if (removeLink) {
      removeLink.click();
    } else {
      removeButton.click();
    }

}